var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.438 16.5v3.438a1.375 1.375 0 001.374 1.375h4.125v-5.5a1.375 1.375 0 011.376-1.376h1.374a1.375 1.375 0 011.376 1.376v5.5h4.124a1.375 1.375 0 001.375-1.375V16.5",
    strokeWidth: 1.191671
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.688 15.125l9.34-9.34a1.375 1.375 0 011.945 0l9.34 9.34",
    strokeWidth: 1.191671
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 8.938V7.562h3.438v4.813M15.695.688l-.373.497a.958.958 0 00.147 1.317h0a.958.958 0 01.146 1.316l-.373.498M19.133.688l-.373.497a.958.958 0 00.146 1.317h0a.958.958 0 01.147 1.316l-.373.498",
    strokeWidth: 1.191671
  }))));
}
export default SvgHouse;